import React from 'react'
import Title from '../../../components/Title/Title'
import OCTable from './components/OCTable/OCTable'
import { array2026 } from '../../../common/constants/organizingCommittee'


const OrganizingCommittee2026page = () => {
    return (
        <div>
            <Title>Organizing Committee</Title>
            <OCTable array={array2026} />
        </div>
    )
}

export default OrganizingCommittee2026page
